module.exports = __webpack_public_path__ + "static/media/05.4d6642da.png";